(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-only"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // On page load, get the first element with data-tab-handle
    const urlParams = new URLSearchParams(window.location.search);
    const urltabValue = urlParams.get('tab');
    let firstTab = document.querySelector('[data-tab-handle]');
    if (urltabValue && document.querySelector(`[data-tab-handle="${urltabValue}"]`)) {
      firstTab = document.querySelector(`[data-tab-handle="${urltabValue}"]`)
    }
    if (firstTab) {
        console.log('firstTab',firstTab)
        const tabValue = firstTab.getAttribute('data-tab-handle');
        document.querySelectorAll('[data-tab-handle]').forEach(element => {
            element.classList.remove('active');
        });
        firstTab.classList.add('active');
        // Get all elements with data-section-handle attribute
        const sections = document.querySelectorAll('[data-section-handle]');
        
        // Add active class to matching sections
        sections.forEach(section => {
            if (section.getAttribute('data-section-handle') === tabValue) {
                section.classList.add('active');
            }
        });
    }


  document.addEventListener('click', function(event) {
      // Check if the clicked element has data-tab-handle attribute
      const clickedElement = event.target;
      if (clickedElement.hasAttribute('data-tab-handle')) {
          // Get the value of data-tab-handle
          const tabValue = clickedElement.getAttribute('data-tab-handle');
          document.querySelectorAll('[data-tab-handle]').forEach(element => {
              element.classList.remove('active');
          });
          clickedElement.classList.add('active');
          
          // Get all elements with data-section-handle attribute
          const sections = document.querySelectorAll('[data-section-handle]');
          
          // Loop through sections and toggle active class
          sections.forEach(section => {
              if (section.getAttribute('data-section-handle') === tabValue) {
                  section.classList.add('active');
              } else {
                  section.classList.remove('active');
              }
          });
      }
  });
});

  } catch(e) { console.error(e); }
})();
})();
